import { publicConfigValue } from "./src/lib/public-config";
import { posthogProxyHost } from "./shared/analytics/posthog-endpoints";

export function posthogProjectToken(): string | undefined {
  return publicConfigValue("NEXT_PUBLIC_POSTHOG_TOKEN") ?? publicConfigValue("NEXT_PUBLIC_POSTHOG_KEY");
}

export function posthogManagedProxyHost(): string {
  return posthogProxyHost(publicConfigValue("NEXT_PUBLIC_POSTHOG_HOST"));
}

export const posthogIngestionHost =
  process.env.POSTHOG_HOST ?? "https://us.i.posthog.com";

export function posthogUiHost(): string {
  return publicConfigValue("NEXT_PUBLIC_POSTHOG_UI_HOST") ?? "https://us.posthog.com";
}
